import '@/shared/csrf-token-deprecated';

import $ from '@/bundles/jquery';
import authPopupHandler from "@/shared/auth-popup-handler";

class LikeButton {
    constructor($stat, active) {
        this.modelId = $stat.data('item');
        this.$stat = $stat;

        if ($stat.find('.num').length > 0) {
            this.init(active);
        }
    }

    init(active) {
        var self = this;

        this.$icon = this.$stat.find('.icon');
        this.$counter = this.$stat.find('.num');
        this.$text = this.$stat.find('.text');
        this.count = this.$counter.data('num');

        if (active) {
            this.makeActive();
        } else {
            this.makeInactive();
        }

        this.$stat.on('click', function () {
            if (self.$stat.hasClass('loading')) {
                return false;
            }

            if (self.$stat.hasClass('js-login-open')) {
                authPopupHandler.showLoginPopup();
                return false;
            }

            var isLiked = self.$stat.hasClass('active');

            self.request(isLiked);

            if (isLiked) {
                self.count--;
                self.makeInactive();
            } else {
                self.count++;
                self.makeActive();
            }

            console.debug(self.count);

            self.updateCounter();
        });
    }

    makeActive() {
        this.$icon.removeClass('far').addClass('fas');
        this.$stat.addClass('active');
        this.$stat.attr('title', 'Unlike');
    }

    makeInactive() {
        this.$icon.removeClass('fas').addClass('far');
        this.$stat.removeClass('active');
        this.$stat.attr('title', 'Like');
    }

    updateCounter() {
        this.$counter.data('num', this.count);
        this.$counter.text(this.count.format(0, '.', ','));

        if (this.$text.length > 0) {
            this.$text.text(this.count === 1 ? 'like' : 'likes');
        }
    }

    request(isLiked) {
        var self = this;

        this.$stat.addClass('loading');

        var url = '/api/v1/3d-models/' + this.modelId + '/like'

        $.ajaxCsrf(url, {
            method: "post",
            data: {
                like: isLiked ? 0 : 1
            },
            // eslint-disable-next-line no-unused-vars
            error: function (xhr) {
                // if (xhr.status == 403) {
                //     WidgetLogin.show();
                // }
            },
            complete: function () {
                self.$stat.removeClass('loading');
            }
        });
    }
}

export default LikeButton;
